var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeveloper = function SvgDeveloper(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "256px",
    height: "165px",
    viewBox: "0 0 256 165",
    style: {
      enableBackground: "new 0 0 256 165"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.4,72.5l-25.9,76.1h-39.3c0-9.8-7.4-17.1-17.7-17.1h-61c0,0-13.9-47.2-21.3-59.2C70.4,64.5,63,59.6,53.3,59.6l0,0 c-15,0-26.3,12.4-34.5,30.3C8.8,111.7,3.1,137.6,2,163h217.5c3.1,0,5.9-2,6.9-5L254,77.1L240.4,72.5z M128,34.6 c0,18-14.6,32.6-32.6,32.6c-18,0-32.6-14.6-32.6-32.6C62.8,16.6,77.4,2,95.4,2c2.1,0,4.1,0.2,6,0.6L94,18.5c-0.3,0-0.7-0.1-1-0.1 c-7.6,0-13.8,6.2-13.8,13.8S85.4,46,93,46s13.8-6.2,13.8-13.8c0-3.7-1.5-7.1-3.9-9.6l7.9-16.8C121,11.4,128,22.2,128,34.6z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeveloper);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/developer.4452bb278d5d9e4dffe63f32ceda15c7.svg";